export default __webpack_public_path__ + "static/media/logo.df1d48a5.png";